import React from 'react';
import {getLocalizedText, texts} from '../../../../../constants/TextConst';
import {Button, Flex} from '@priority-software/priority-style-react';
import styles from '../../styles/labelSettings.module.scss';

export const Footer = ({handleSave, handlePrint, state}: any) => {
    const renderTitle = () => {
        const {mayPrint, isAll} = state;
        if (mayPrint) {
            return getLocalizedText(texts.print);
        }
        if (isAll) {
            return getLocalizedText(texts.prepareLabel);
        }

        return getLocalizedText(texts.confirmLabel);
    };

    return (
        <Flex justifyContent="space-between" componentClasses={styles.footer}>
            <Flex justifyContent="flex-start">
                <Button
                    componentClasses={styles.acceptButton}
                    name={'save'}
                    onClick={handleSave}
                    size="large"
                    skin="primary"
                    disabled={!state.isDirty}
                >
                    {getLocalizedText(texts.saveSettings)}
                </Button>
                <Button
                    onClick={handlePrint}
                    autoFocus={true}
                    size="large"
                    name={'print'}
                    skin="secondary"
                >
                    {renderTitle()}
                </Button>
            </Flex>
        </Flex>
    );
};
